import {Component} from "../../../../../../sedestral/framework/interface/component/Component";
import {NetworkVendor} from "../../../../../../network/NetworkVendor";
import * as s from "./website-black-score.scss";
import {Resources} from "../../../../../../resources/Resources";
import {isMobile} from "../../../../../../sedestral/framework/utilities/IsMobile";

export class WebsiteBlackScoreComponent extends Component {
    constructor() {
        super();

        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteBlackScore}">
                <div class="${s.image}">
                    <img class="${s.screen}" src="${NetworkVendor.image("blog-x.webp")}"
                         alt="${Resources.t("words.contentEditorScreenshot")}"/>
                    <img class="${s.score}" src="${NetworkVendor.image("blog-y.webp")}"
                         alt="${Resources.t("words.contentScoreScreenshot")}"/>
                </div>
                <div class="${s.case}">
                    <div class="${s.scoreIcon}">
                        <div class="${s.aiShadow}"></div>
                        <div class="${s.aiIcon}"></div>
                    </div>
                    <h3 class="${s.text}">
                        ${Resources.t("words.realTimeSeoScore")}
                    </h3>
                    <div class="${s.scoreMobileContainer}">
                        <img class="${s.scoreMobile}" src="${NetworkVendor.image("blog-y.webp")}"
                             alt="${Resources.t("words.contentScoreScreenshot")}"/>
                    </div>
                </div>
            </div>
        `;
    }

    commit() {
        let screen = this.el(s.screen);
        let score = this.el(s.score);
        let theCase = this.el(s.case);

        if (!isMobile()) {
            this.putListener(window, "scroll", () => {
                let top = this.getOffsets().top - 100;
                if (top <= 0) {
                    if (theCase.getOffsets().top > 100) {
                        let translateY = Math.abs(top);
                        let translateX = Math.min((translateY / 240) * 38, 38);
                        let scale = Math.min(1 + (translateY / 240) * 0.1, 1.1);
                        let opacity = Math.max(1 - (translateY / 240) * 0.75, 0.25);


                        score.setStyle(`transform: translateY(${translateY}px) scale(${scale}) translateX(${-translateX}px);`);
                        screen.setStyle(`opacity: ${opacity}`);
                    }
                } else {
                    score.setStyle(`transform: translateY(0px) scale(1) translateX(0px);`);
                    screen.setStyle(`opacity: 1;`);
                }
            });
        }

        super.commit();
    }
}